export default "__VITE_ASSET__DDGa9GDA__"